// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/bundle." + "3fcc0e0c08e90d8a" + ".js";
};